import { render, staticRenderFns } from "./AccountingBankTransferDetail.vue?vue&type=template&id=4b9b4e02&"
import script from "./AccountingBankTransferDetail.vue?vue&type=script&lang=js&"
export * from "./AccountingBankTransferDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBankTransferDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports